
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/child-custody",
      function () {
        return require("private-next-pages/practice-areas/child-custody/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/child-custody"])
      });
    }
  